import { configureStore } from "@reduxjs/toolkit";
import userReducer from "@/auth/authSlice";
import currentSearchReducer from "./currentSearchSlice";
import searchReducer from "./searchSlice";
import searchInputReducer from "./searchInputSlice";
import profileReducer from "./profileSlice";
import loadVolumeReducer from "./loadVolumeSlice";
import rateHistoryReducer from "./rateHistorySlice";
import loadRatesReducer from "./loadRatesSlice";
import bestOutboundsReducer from "./bestOutboundsSlice";
import marketPotentialReducer from "./marketPotentialSlice";
import mapDataReducer from "./mapDataSlice";
import trendsReducer from "./trendsSlice";
import loadSearchReducer from "./loadSearchSlice";
import openedLoadReducer from "./openedLoadSlice";
import offersReducer from "./offersSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    currentSearch: currentSearchReducer,
    search: searchReducer,
    searchInput: searchInputReducer,
    profile: profileReducer,
    loadVolume: loadVolumeReducer,
    rateHistory: rateHistoryReducer,
    loadRates: loadRatesReducer,
    bestOutbounds: bestOutboundsReducer,
    marketPotential: marketPotentialReducer,
    mapData: mapDataReducer,
    trends: trendsReducer,
    loadSearch: loadSearchReducer,
    openedLoad: openedLoadReducer,
    offers: offersReducer,
  },
});

export default store;
